import { MAIL_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaGeneralEventApiResponse } from './GeneralResponse';

export const schemaEmailMessageCreated = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            attachments: z
                .array(
                    z.object({
                        fileExtension: z.string().min(1),
                        key: z.string().min(1),
                        mimeType: z.string().min(1),
                        name: z.string().min(1),
                    }),
                )
                .nullish(),
            bcc: z.array(z.string().email()).nullish(),
            body: z.object({
                html: z.string().optional(),
                text: z.string().min(1),
            }),
            cc: z.array(z.string().email()).nullish(),
            from: z.string().email(),
            fromName: z.string().optional(),
            fromUserId: z.string().min(1).optional(),
            smime: z.object({ cert: z.string(), key: z.string() }).optional(),
            subject: z.string().min(1),
            substitutions: z
                .record(z.string(), z.string().or(z.object({ html: z.string(), txt: z.string() })))
                .optional(),
            to: z.string().email(),
            toName: z.string().optional(),
            type: z.nativeEnum(MAIL_TYPES).optional(),
        }),
        type: z.literal('KreditDE_LoanRequest_EmailMessageCreated'),
    }),
);

export const schemaEmailMessageCreationFailed = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            additionalInfo: z.record(z.string(), z.any()).optional(),
            failureReason: z.string(),
        }),
        type: z.literal('KreditDE_LoanRequest_EmailMessageCreationFailed'),
    }),
);

export const schemaEmailMessageFailed = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            error: z.string().min(1),
        }),
        type: z.literal('KreditDE_LoanRequest_EmailMessageFailed'),
    }),
);

export const schemaEmailMessageSent = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            info: z.object({
                accepted: z.array(z.string().email()).nullish(),
                envelope: z.object({
                    from: z.string().email(),
                    to: z.array(z.string().email()).nullish(),
                }),
                messageId: z.string().min(1),
                pending: z.array(z.string().email()).nullish(),
                rejected: z.array(z.string().email()).nullish(),
                response: z.string().min(1),
            }),
        }),
        type: z.literal('KreditDE_LoanRequest_EmailMessageSent'),
    }),
);

export const schemaMessageEventApiResponse = z.discriminatedUnion('type', [
    schemaEmailMessageCreated,
    schemaEmailMessageCreationFailed,
    schemaEmailMessageFailed,
    schemaEmailMessageSent,
]);

export type MessageEventApiResponse = z.infer<typeof schemaMessageEventApiResponse>;
export type EmailMessageCreated = z.infer<typeof schemaEmailMessageCreated>;
export type EmailMessageCreationFailed = z.infer<typeof schemaEmailMessageCreationFailed>;
export type EmailMessageFailed = z.infer<typeof schemaEmailMessageFailed>;
export type EmailMessageSent = z.infer<typeof schemaEmailMessageSent>;
